<script>
import {useStore} from "vuex";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import $ from "jquery";

export default {
  name: "CartInfoSend",
  components: {LoadingPage},

  setup() {

    let store = useStore()
    let address = ref(store.state.address)
    let products = store.state.order.products
    let factor = store.state.order.factor

    let privacy = ref(false)

    let loading = ref(false)

    let dialog = ref(false)

    let data = ref({
      sid: null,
      aid: null,
      info: '',
      factor: false,
      offer_id : null,
      pids: [],
    })


    function delete_address(item) {

      Swals.Question('آیا از حذف این آدرس اطمینان دارید؟', 'حذف کردن').then((res) => {
        if (res.isConfirmed) {
          loading.value = true
          FreeWorld.Heisenberg({action: 'address_delete', aid: item.id}, 'info').then((res) => {

            loading.value = false
            if (res.data.status === 'ok') {

              Swals.Done('آدرس مورد نظر شما با موفقیت حذف شد')
              $("#Address" + item.id).removeClass('animate__fadeInDown').addClass('animate__backOutDown')
              setTimeout(() => {
                store.commit('delete_address', item)
              }, 500)

            } else {
              Swals.Fault('متاسفانه آدرس مورد نظر شما حذف نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => delete_address(item))
          })


        }
      })

    }

    function complete_orders() {

      if (products.length === 0) {
        Swals.Warning('در حال حاضر محصولی در سبد خرید شما وجود ندارد!', 'HomePage');
        return false
      }
      if (data.value.aid === null) {
        Swals.Warning('لطفا آدرس خود را انتخاب کنید!');
        return false
      }
      if (privacy.value === false) {
        Swals.Warning('پذیرفتن شرایط و قوانین ارسال الزامی است!');
        return false
      }

      if (data.value.info.trim().length === 0) data.value.info = null

      // if (factor){data.value.factor = 1}else{data.value.factor = 0}
      data.value.factor = factor ? 1 : 0;


      data.value.sid = products[0].shop.id
      products.forEach((item) => {
        data.value.pids.push({id: item.pid, number: item.shop.number})
      })

      if (store.state.order.offer !== null) data.value.offer_id = store.state.order.offer

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'order_new', true).then((res) => {

        loading.value = false
        if (res.data.status === 'ok') {
          store.commit('EmptyBasket')
          dialog.value = true
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, complete_orders)
      })

    }

    function close_cart() {
      Swals.Question('آیا از حذف سبد خرید خود اطمینان دارید؟', 'حذف سبد خرید').then((res) => {
        if (res.isConfirmed) {
          store.commit('EmptyBasket')
          Swals.Done('سبد خرید شما با موفقیت حذف شد', 'HomePage')
        }
      })
    }

    return {

      address,
      data,
      privacy,
      complete_orders,
      loading,
      delete_address,
      dialog,
      close_cart,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <router-link v-if="dialog" :to="{name:'HomePage'}" class="bg_dialog"></router-link>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <div @click="close_cart" class="d-flex align-items-center">
        <p class="font-4 font-color">انصراف</p>
        <img src="../assets/img/closing_color.svg" alt="" class="svg-arrow">
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مشاهده سبد خرید</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">


      <div class="bg-white rounded-4 shadow-custom mb-5">

        <div class="d-flex align-items-center justify-content-between mb-3 overflow-hidden">

          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons icon_shadow mb-2" src="../assets/img/BuyBox_lighte.svg" alt="">
            <p class="font-4 font-color_light">سبد خرید</p>
          </div>
          <div class="d-flex sss w-30 p-2 flex-column align-items-center rounded-top-4 shadow_select">
            <img class="icons icon_shadow mb-2" src="../assets/img/gps_color.svg" alt="">
            <p class="font-5 font-color">اطلاعات ارسال</p>
          </div>
          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons icon_shadow mb-2" src="../assets/img/card-payment-light.svg" alt="">
            <p class="font-5 font-color_light">اطلاعات پرداخت</p>
          </div>

        </div>


        <div class="p-body">
          <p class="font-4 font-bold mb-2 font-color">انتخاب آدرس</p>

          <div class="">
            <div class="rounded-4 bg-color-blue-light p-2 mb-3 shadow-custom">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <p class="font-4 font-bold">آدرس</p>

                <router-link :to="{name:'AddAddress'}" class="text-decoration-none d-flex align-items-center">
                  <img src="../assets/img/add_color.svg" alt="" class="icon_shadow icon-size-2 ml-2">
                  <p class="font-5 font-color">افزودن آدرس</p>
                </router-link>
              </div>

              <div class="list_address">

                <div v-for="item in address" :key="item.id"
                     :class="data.aid === item.id ? 'bg-color text-white':'bg-white' " :id="'Address' + item.id"
                     class="animate__animated animate__fadeInDown d-flex align-items-center justify-content-between p-2 shadow-custom rounded-3 mb-2">
                  <div @click="data.aid = item.id" class="d-flex align-items-center w-85">
                    <img v-if="data.aid === item.id" class="icon-size-2" src="../assets/img/address_white.svg" alt="">
                    <img v-else class="icon-size-2" src="../assets/img/address_color.svg" alt="">

                    <p class="font-5 mr-2">{{ item.address }}</p>
                  </div>

                  <img @click="delete_address(item)" class="icon_shadow icon-size-4"
                       src="../assets/img/delete_address.svg" alt="">
                </div>

              </div>

            </div>

          </div>

          <p class="font-4 font-bold mb-2 font-color">توضیحات سفارش</p>
          <textarea v-model="data.info" class="info rounded-4 bg-white p-3 mb-2 w-100 shadow-custom font-4"
                    placeholder="اختیاری"></textarea>

          <div class="shadow-custom rounded-3 p-2 d-flex align-items-center mb-4">
            <input v-model="privacy" class="ml-2" id="factor" type="checkbox">
            <label class="font-4 font-color" for="factor">تمام <a href="https://market-app.ir/rules?action=rules" target="_blank" class="font-color_light">شرایط و قوانین</a> ارسال را
              میپذیرم</label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mb-3">
        <v-btn @click="complete_orders" class="bg-color h-100 rounded-4 p-3 font-4 shadow-custom text-white w-90">ثبت
          سفارش نهایی
        </v-btn>
      </div>

    </div>


    <div v-if="dialog" class="dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_done_dialog.svg" alt="">
          <p class="text-white font-4">ثبت نهایی خرید</p>
        </div>

        <div class="d-flex justify-content-center align-items-center p-5">
          <p class="font-4 text-center">کاربر عزیز سفارش شما با موفقیت ثبت شد برای پرداخت و تایید سفارش از طریق پیامک به شما اطلاع رسانی میشود</p>
        </div>
      </div>
    </div>

  </div>

</template>


<style scoped>

.icons {
  width: 2rem;
  height: 2rem;
}
.shadow_select {
  box-shadow: 0 -7px 15px -5px #707070;
}
.info {
  height: 10rem;
  resize: none;
}
.info::placeholder {
  text-align: center;
}
.list_address {
  max-height: 23vh;
  overflow-y: scroll;
}


</style>